<div #mapContainer class="map-container"></div>
<div class="d-flex">
  <button class="btn btn-xs btn-theme flex-1" (click)="findLocation()">
    <ng-container *ngIf="!(locationLoading | async)">
      Find Location
    </ng-container>
    <ng-container *ngIf="(locationLoading | async)">
      <span class="indicator-progress" [style.display]="'block'">
          Finding...
          <span
            class="spinner-border spinner-border-sm align-middle ms-2"
          ></span>
        </span>
    </ng-container>
  </button>
  <button class="btn btn-xs btn-theme-secondary flex-1" (click)="resetMarker()">Reset Marker</button>
</div>
